// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_7ec5dd', '__Poppins_Fallback_7ec5dd'","fontStyle":"normal"},"className":"__className_7ec5dd","variable":"__variable_7ec5dd"};